// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';

/**
 * @typedef {Object} ResponseGetKriptoPaymentById
 * @property {Object} data - Objeto con los datos del cliente
 */

/**
 * Obtener datos del kriptopayment segun su ID
 * @param {String | Number} kriptoPaymentId - Id del kriptopayment a buscar
 * @returns {Promise<AxiosResponse<ResponseGetKriptoPaymentById>>} Informacion del kriptopayment
 */
const getClientById = (kriptoPaymentId) =>
  axiosInstance.get(`/internal/admin/kriptopayments/${kriptoPaymentId}`);

export default getClientById;
